import { createAction } from '@reduxjs/toolkit';
import { CALC_ENGINE_ACTION_PREFIX } from '../utilities/constants';

export const linkedAdjustmentsForDocumentUpdated = createAction(
  `${CALC_ENGINE_ACTION_PREFIX}/addLinkedAdjustment`,
  (documentCode, linkedAdjustments) => {
    return { payload: { documentCode, linkedAdjustments } };
  }
);
